import { render, staticRenderFns } from "./ArrivalForm.vue?vue&type=template&id=523ec4f7&scoped=true&"
import script from "./ArrivalForm.vue?vue&type=script&lang=js&"
export * from "./ArrivalForm.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalForm.vue?vue&type=style&index=0&id=523ec4f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ec4f7",
  null
  
)

export default component.exports